import { render, staticRenderFns } from "./WhyWeAskThis.vue?vue&type=template&id=b53529e0&scoped=true"
import script from "./WhyWeAskThis.vue?vue&type=script&lang=js"
export * from "./WhyWeAskThis.vue?vue&type=script&lang=js"
import style0 from "./WhyWeAskThis.vue?vue&type=style&index=0&id=b53529e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53529e0",
  null
  
)

export default component.exports